import {Component, OnInit} from '@angular/core';
import {InfoDialogComponent} from '../info-dialog/info-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-info-cesium-btn',
  templateUrl: './info-cesium-btn.component.html',
  styleUrls: ['./info-cesium-btn.component.css']
})
export class InfoCesiumBtnComponent implements OnInit {

  showInfo = true;

  constructor(public dialog: MatDialog) {
  }

  ngOnInit() {

  }

  openDialog() {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: '800px',
      data: {show: false},
      panelClass: 'info-overlay'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
